import { CoveoFacet } from "~/types";

export const imagePlaceholderProduct = '/images/product_placeholder.svg';

export function handleImageError(e: any) {
  e.target.src = imagePlaceholderProduct;
  e.target.srcset = imagePlaceholderProduct;
}

export function getBreadcrumbs(currentRoute: string[], localePath: any) {

  return currentRoute?.map((breadcrumbItem, index) => {
    const subRoute = currentRoute.slice(0, index + 1).join("/");

    return {
      text: breadcrumbItem
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      link:
        index < currentRoute.length
          ? localePath(`/${subRoute}`)
          : breadcrumbItem,
    };
  });
}

export const coveoFieldsToInclude = [
  "classification_productgenerictype",
  "classification_productspecifictype",
  "price_discounted",
  "price_regular",
  "shortname",
  "imageurl",
  "lowest_price",
  "stock",
  "ec_shortname",
  "onlyavailableto",
  "onlinefrom",
  "price_discounted_6001",
  "price_discountpercentage_6001",
  "price_discountpercentage",
  "price_regular_6001",
  "addtocarthidden"
];

export const coveoFacetsProperties: CoveoFacet[] = [
    {
      displayName: "FACETS.PRODUCT_TYPE",
      facetId: "classification_productspecifictype",
      displayFacetNumbers: true,
      displayItems: 1
    },
    // {
    //   displayName: "FACETS.COLOR",
    //   facetId: "simplifiedcolorcode",
    //   displayFacetNumbers: true,
    //   displayItems: 6
    // },
    {
      displayName: "FACETS.COLLECTION",
      facetId: "classification_collection",
      displayFacetNumbers: true,
      displayItems: 5
    },
    {
      displayName: "FACETS.PRICE",
      facetId: "price_regular",
      displayFacetNumbers: true,
      displayItems: 5
    },
    {
      displayName: "FACETS.SIZE",
      facetId: "classification_size",
      displayFacetNumbers: true,
      displayItems: 5
    }
];

export enum CarouselType {
  popularItemsBought = "popularitemsbought",
  popularItemsViewed = "popularitemsviewed",
  frequentlyBoughtTogether = "frequentlyboughttogether",
}